module.exports = __webpack_public_path__ + "img/temp.62a8b58a.svg";